export default "__VITE_ASSET__BEkhn114__"